//Comments component
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EmojiPicker from "emoji-picker-react";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  likeFeedOrComment,
  postCreateComment,
  unlikeFeedOrComment,
  usePaginateComments,
} from "../../utils/api/functions/advancedActivityFeeds";
import {
  postCreateCommentBasic,
  usePaginateCommentsBasic
} from "../../utils/api/functions/likesComments";
import { useGetUserInfo } from "../../utils/api/functions/members";
import { FeedContext } from "../../utils/context/feedContext";
import { relativeTimeFormat } from "../../utils/parsing";

 
export const CreateComment = ({
  action_id,
  nested,
  hideProfilePicture = false,
  subject_type = false,
}) => {
  const { data } = useGetUserInfo({
    user_id: window.localStorage.getItem("user_id"),
  });
  // const {data: comment_data, mutate} = useGetLikesCommentsBasic({
  //   subject_id: String(action_id), 
  //   subject_type: String(subject_type), 
  //   viewAllComments: String(1)
  // });  

  const [profilePic, setProfilePic] = useState("");
  const [commentText, setCommentText] = useState("");
  const [sending, setSending] = useState(false);
  const [isFocused, setIsFocused] = useState(false); 
  const [showEmoji, setShowEmoji] = useState(false); 

 

  const { handleUpdate } = useContext(FeedContext);

  useEffect(() => {
    if (data && data.body && data.body.response) {
      setProfilePic(data.body.response.image_icon);
    }
  }, [data]);

  const handleChange = (e) => {
    setCommentText(e.target.value);
  };

  const handleSubmit = async () => {
    if (sending) return;
    setSending(true);
    const _formData = new FormData();

    if (subject_type !== false) {
      _formData.append("subject_type", subject_type);
      _formData.append("subject_id", action_id);
      _formData.append("body", commentText);
      const result = await postCreateCommentBasic(_formData);
      if (result?.status_code === 200) {
        toast.success("Comment created successfully");
        // mutate();
      } else {
        toast.error("Error creating comment");
      }
    } else {
      _formData.append("action_id", action_id);
      _formData.append("body", commentText);
      const result = await postCreateComment(_formData);


      if (result?.status_code === 200) {
        toast.success("Comment created successfully");
        // mutate();
        handleUpdate(action_id, result.body);
        
      } else {
        toast.error("Error creating comment");
      }
    }

    setCommentText("");
    setSending(false);
  };

  const handleOnFocus = () => {
    setIsFocused(true); 
  }
  const handleBlur = (e) => {
    console.log(e)
    console.log(e.relatedTarget); 
    setIsFocused(false)
  }

  const toggleEmojiPicker = (e) => {
    e.preventDefault();
    setShowEmoji(!showEmoji); 
  }

  const onEmojiClick = (e, emojiObject) => {
    setCommentText(commentText + emojiObject.emoji); 
  }

  return (
    <div className={`comment-create ${nested ? "nested" : ""}`}>
      {!hideProfilePicture ? (
        <div>
          <img src={profilePic} />
        </div>
      ) : null}
      <div className="col comment-create-text-box-container"
        
      >
        <textarea
          placeholder="Write a comment..."
          value={commentText}
          onChange={handleChange}
          maxLength={1000}
        ></textarea>
        
        {
          showEmoji ? (<EmojiPicker
            pickerStyle={{
              position: 'absolute',
              zIndex: 9999,
              left: "2rem"
            }}
            onEmojiClick={onEmojiClick}
            disableAutoFocus
          />) : (null)
        }
        
        <div className="comment-create-emoji-picker">
          <span onClick={toggleEmojiPicker} style={{cursor: "pointer"}}>😃</span>
        </div>
        

        {commentText.length > 0 ? <div>{commentText.length}/1000</div> : null}
        <div className="comment-create-text-box-send-btn">
          <FontAwesomeIcon icon={faPaperPlane} onClick={handleSubmit} />
        </div>
      </div>
    </div>
  );
};

const CommentActions = ({ handles, is_like, comment_id, action_id }) => {
  const [isLiked, setIsLiked] = useState(is_like);
  const [showCreateComment, toggleComment] = useState(false);

  const handleToggle = () => {
    toggleComment(!showCreateComment);
  };
  const { handleLike, handleUnlike } = handles;

  return (
    <>
      <div className="comment-item-actions">
        <p>
          <span
            onClick={handleToggle}
            className={showCreateComment ? "comment-item-actions-active" : ""}
          >
            Reply
          </span>
          <span
            className={isLiked ? "comment-is-liked" : ""}
            onClick={
              isLiked
                ? () => {
                    handleUnlike(action_id, comment_id);
                    setIsLiked(false);
                  }
                : () => {
                    handleLike(action_id, comment_id);
                    setIsLiked(true);
                  }
            }
          >
            Like
          </span>
        </p>
      </div>
      {showCreateComment ? <CreateComment nested={true} action_id={comment_id}/> : null}
    </>
  );
};

//Loads in Post feed
export const Comments = ({ comment_data, action_id, total_count }) => {
  const [expandedComments, setExpandedComments] = useState({});
  const totalCountNumber = useMemo(() => {
    if (total_count == null) return null;
    const parsed = typeof total_count === "number" ? total_count : Number(total_count);
    return Number.isFinite(parsed) ? parsed : null;
  }, [total_count]);
  const initialComments = useMemo(() => {
    if (!comment_data) return [];
    const data =
      (Array.isArray(comment_data?.data) && comment_data.data) ||
      (Array.isArray(comment_data?.viewAllComments) && comment_data.viewAllComments) ||
      (Array.isArray(comment_data?.comments) && comment_data.comments) ||
      (Array.isArray(comment_data?.body?.viewAllComments) && comment_data.body.viewAllComments) ||
      (Array.isArray(comment_data?.body?.comments) && comment_data.body.comments) ||
      (Array.isArray(comment_data?.body?.data) && comment_data.body.data) ||
      [];

    return data;
  }, [comment_data]);

  const initialPage = useMemo(() => {
    if (comment_data?.page) return Number(comment_data.page);
    if (comment_data?.current_page) return Number(comment_data.current_page);
    if (comment_data?.page_number) return Number(comment_data.page_number);
    if (comment_data?.body?.page) return Number(comment_data.body.page);
    if (comment_data?.body?.current_page) return Number(comment_data.body.current_page);
    if (comment_data?.body?.page_number) return Number(comment_data.body.page_number);
    return 1;
  }, [comment_data]);

  const [paginationEnabled, setPaginationEnabled] = useState(false);

  const getCommentKey = useCallback((comment) => {
    if (!comment) return null;

    const stableId = comment.comment_id ?? comment.id ?? comment.guid;
    if (stableId != null) {
      return String(stableId);
    }

    const author = comment.poster_id ?? comment.user_id ?? "anon";
    const created = comment.creation_date ?? comment.comment_date ?? "unknown";
    const body = comment.body ?? comment.comment_body ?? "";

    return `${author}-${created}-${body}`;
  }, []);

  const getFallbackKey = useCallback(
    (comment, fallbackIndex) => getCommentKey(comment) ?? `comment-${fallbackIndex}`,
    [getCommentKey]
  );

  const getCommentTimestamp = useCallback((comment) => {
    if (!comment) return 0;
    const rawDate = comment.creation_date ?? comment.comment_date;
    if (!rawDate) return 0;
    const parsed = Date.parse(`${rawDate} UTC`) || Date.parse(rawDate);
    return Number.isFinite(parsed) ? parsed : 0;
  }, []);

  const shouldEnablePagination = Boolean(
    paginationEnabled &&
      action_id &&
      totalCountNumber != null &&
      totalCountNumber > initialComments.length
  );

  const {
    data: paginatedPages,
    error: paginationError,
    isValidating: isPaginating,
    setSize,
  } = usePaginateComments(
    {
      action_id,
      page: Number.isFinite(initialPage) ? initialPage + 1 : 2,
    },
    {
      enabled: shouldEnablePagination,
    }
  );

  const extraComments = useMemo(() => {
    if (!paginatedPages || paginatedPages.length === 0) return [];

    return paginatedPages
      .filter(Boolean)
      .flatMap((page) => {
        const body = page?.body ?? page ?? {};
        if (Array.isArray(body.viewAllComments)) return body.viewAllComments;
        if (Array.isArray(body.comments)) return body.comments;
        if (Array.isArray(body.data)) return body.data;
        if (Array.isArray(page?.comments)) return page.comments;
        return [];
      });
  }, [paginatedPages]);

  const combinedComments = useMemo(() => {
    const initialList = Array.isArray(initialComments) ? initialComments : [];
    const extraList = Array.isArray(extraComments) ? extraComments : [];
    const allComments = [...extraList, ...initialList];
    const unique = [];
    const seen = new Set();

    allComments.forEach((comment, index) => {
      if (!comment) return;
      const id = getFallbackKey(comment, index);
      if (id != null && seen.has(id)) {
        return;
      }
      if (id != null) {
        seen.add(id);
      }
      unique.push(comment);
    });

    unique.sort((a, b) => getCommentTimestamp(b) - getCommentTimestamp(a));

    return unique;
  }, [initialComments, extraComments, getFallbackKey, getCommentTimestamp]);

  const initialCommentRefs = useMemo(() => {
    const refs = new Set();
    (Array.isArray(initialComments) ? initialComments : []).forEach((comment) => {
      if (comment) {
        refs.add(comment);
      }
    });
    return refs;
  }, [initialComments]);

  const initialCommentCount = initialCommentRefs.size;

  const remainingCount = useMemo(() => {
    if (totalCountNumber == null) return 0;
    return Math.max(totalCountNumber - combinedComments.length, 0);
  }, [combinedComments.length, totalCountNumber]);

  const showLoadMore = remainingCount > 0;
  const hasExtraComments = combinedComments.length > initialCommentCount;

  const [showInitialOnly, setShowInitialOnly] = useState(false);

  const visibleComments = useMemo(() => {
    if (!showInitialOnly) {
      return combinedComments;
    }
    return combinedComments.filter((comment) => initialCommentRefs.has(comment));
  }, [showInitialOnly, combinedComments, initialCommentRefs]);

  const handleLike = async (post_action_id, comment_id) => {
    let formData = new FormData();
    let postData = {
      action_id: post_action_id,
      comment_id: comment_id,
    };
    for (let key in postData) {
      formData.append(key, postData[key]);
    }
    await likeFeedOrComment(formData);
  };
  const handleUnlike = async (post_action_id, comment_id) => {
    let formData = new FormData();
    let postData = {
      action_id: post_action_id,
      comment_id: comment_id,
    };
    for (let key in postData) {
      formData.append(key, postData[key]);
    }
    await unlikeFeedOrComment(formData);
  };

  const handleLoadMore = () => {
    if (!showLoadMore || isPaginating) {
      return;
    }
    setShowInitialOnly(false);
    if (!paginationEnabled) {
      setPaginationEnabled(true);
      setSize(1);
    } else {
      setSize((current) => current + 1);
    }
  };

  useEffect(() => {
    setPaginationEnabled(false);
    setExpandedComments({});
    setShowInitialOnly(false);
  }, [action_id]);

  if (!comment_data || combinedComments.length === 0) {
    return null;
  }

  return (
    <div className="comments-thread">
      {visibleComments.map((item, index) => {
        if (item.isLoading) return <div>BIG TEST</div>;
        const commentKey = getFallbackKey(item, index);
        const authorId = item.poster_id ?? item.user_id;
        const authorName = item.poster_displayname ?? item.author_title ?? "Unknown";
        const authorPhoto = item.author_image_profile ?? item.poster_photo ?? "";
        const commentText = item.body ?? item.comment_body ?? "";
        const createdAt = item.creation_date ?? item.comment_date ?? null;
        const parentActionId = item.resource_id ?? item.action_id ?? action_id;
        const isExpanded = Boolean(expandedComments[commentKey]);
        const toggleExpanded = () => {
          setExpandedComments((prev) => ({
            ...prev,
            [commentKey]: !prev[commentKey],
          }));
        };

        return (
          <div className="comment-item" key={`comment-${commentKey}`}>
            <div className="col-1 comment-item-profile-pic">
              <Link to={`/profile/${authorId}`}>
                <img src={authorPhoto}></img>
              </Link>
            </div>
            <div className="col comment-item-body">
              <p className="author-item-name">
                <Link
                  to={`/profile/${authorId}`}
                  className="author-item"
                  reloadDocument
                >
                  {authorName}
                </Link>
              </p>
              <OverlayTrigger
                placement="right"
                overlay={
                  createdAt ? (
                    <Tooltip id="tooltip">{new Date(`${createdAt} UTC`).toLocaleString()}</Tooltip>
                  ) : (
                    <Tooltip id="tooltip">Recent</Tooltip>
                  )
                }
              >
                <p style={{
                  fontSize: "0.75rem",
                  display: "inline-block"
                }}>
                  {createdAt ? relativeTimeFormat(new Date(`${createdAt} UTC`)) : "Just now"}
                </p>
              </OverlayTrigger>
              
              <p className="comment-item-text">
                {isExpanded ? commentText : commentText.slice(0, 250)}
                {commentText.length > 250 && (
                  <span
                    className="show-more-less-btn"
                    onClick={toggleExpanded}
                  >
                    {isExpanded ? " Show less" : "... Show more"}
                  </span>
                )}
              </p>
              <CommentActions
                handles={{
                  handleLike: handleLike,
                  handleUnlike: handleUnlike,
                }}
                is_like={item?.like?.isLike}
                action_id={parentActionId}
                comment_id={item.comment_id}
                item={item}
              />
            </div>
          </div>
        );
      })}

      {paginationError ? (
        <div className="text-danger small mt-2">Unable to load more comments right now.</div>
      ) : null}

      {(showLoadMore || hasExtraComments) ? (
        <div className="comment-controls comment-controls-inline">
          {showLoadMore ? (
            <span
              className="comment-control-link"
              style={{
                fontSize: "0.85rem",
                marginRight: hasExtraComments ? "1rem" : 0,
                cursor: isPaginating ? "default" : "pointer",
                opacity: isPaginating ? 0.7 : 1,
              }}
              role="button"
              tabIndex={0}
              aria-disabled={isPaginating}
              onClick={() => {
                if (!isPaginating) {
                  handleLoadMore();
                }
              }}
              onKeyDown={(event) => {
                if (isPaginating) return;
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  handleLoadMore();
                }
              }}
            >
              {isPaginating
                ? "Loading more comments..."
                : `View more comments${remainingCount ? ` (${remainingCount})` : ""}`}
            </span>
          ) : null}

          {hasExtraComments ? (
            <span
              className="comment-control-link"
              style={{ fontSize: "0.85rem", cursor: "pointer" }}
              role="button"
              tabIndex={0}
              onClick={() => setShowInitialOnly((prev) => !prev)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  setShowInitialOnly((prev) => !prev);
                }
              }}
            >
              {showInitialOnly ? "Show all comments" : "Show fewer comments"}
            </span>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

const LoadMoreComments = ({_loadMore}) => {

  return(
    <div onClick={_loadMore}
        style={{
          cursor: 'pointer'
        }}
      >
        <span>Load More Comments</span>
    </div>
  )
}

export const BasicComments = ({ subject_id, subject_type }) => {
  const { data, mutate, size, setSize } = usePaginateCommentsBasic({
    subject_id: String(subject_id),
    subject_type: String(subject_type),
    viewAllComments: String(1),
  });
  const [fetchedComments, setComments] = useState([]);
  const [totalComments, setTotalComments] = useState(0);
  const [showMore, setShowMore] = useState(false);
  const likeFn = async (action_id, comment_id, updated_object) => {
    let formData = new FormData();
    let postData = {
      action_id: action_id,
      comment_id: comment_id,
    };
    for (let key in postData) {
      formData.append(key, postData[key]);
    }
    let res = await likeFeedOrComment(formData);
    if (res.status_code == 204 || res.status_code == 200) {
      return { ...updated_object };
    } else {
      throw new Error("Invalid API Response");
    }
  };
  const unlikeFn = async (action_id, comment_id, updated_object) => {
    let formData = new FormData();
    let postData = {
      action_id: action_id,
      comment_id: comment_id,
    };
    for (let key in postData) {
      formData.append(key, postData[key]);
    }
    let res = await unlikeFeedOrComment(formData);
    if (res.status_code == 204 || res.status_code == 200) {
      return { ...updated_object };
    } else {
      throw new Error("Invalid API Response");
    }
  };
  const handleLike = async (action_id, comment_id) => {
    let updated_object = new Object({ ...data });
    for (let i = 0; i < updated_object.body.viewAllComments.length; i++) {
      let item = updated_object.body.viewAllComments[i];
      if (item.comment_id == comment_id) {
        updated_object.body.viewAllComments[i].like.isLike = 1;
        break;
      }
    }

    mutate(likeFn(action_id, comment_id, updated_object), {
      optimisticData: {
        ...updated_object,
        body: {
          ...updated_object.body,
          ...updated_object.body.viewAllComments,
        },
      },
      rollbackOnError: true,
      populateCache: true,
      revalidate: false,
    });
  };
  const handleUnlike = async (action_id, comment_id) => {
    let updated_object = new Object({ ...data });

    for (let i = 0; i < updated_object.body.viewAllComments.length; i++) {
      let item = updated_object.body.viewAllComments[i];
      if (item.comment_id == comment_id) {
        updated_object.body.viewAllComments[i].like.isLike = 0;
        break;
      }
    }

    await mutate(unlikeFn(action_id, comment_id, updated_object), {
      optimisticData: { 
        ...updated_object,
        body: {
          ...updated_object.body,
          ...updated_object.body.viewAllComments,
        },
      },
      rollbackOnError: true,
      populateCache: true,
      revalidate: false,
    });
  };

  const _loadMore = () => {
    setSize(size+1); 
  }

  useEffect(() => {
    //Clear comments before fetching new ones (triggers on component mount)
    setComments(() => []);

    let new_list = [];
    console.log("COMMENT DATA: ", data)
    if(!data) return; 
    for(let i = 0; i<data.length; i++){
      if(!data[i].body) return
      new_list = [...new_list, ...data[i].body.viewAllComments]
    }
    setComments(() => new_list);
    setTotalComments(data.slice(-1)[0].body.getTotalComments); 
    // if (
    //   data &&
    //   data.body &&
    //   data.body.viewAllComments &&
    //   data.body.viewAllComments.length > 0
    // ) {
    //   new_list = [...data.body.viewAllComments];
    //   setComments(() => new_list);
    // }
  }, [data]);

  return (
    <>
      {fetchedComments.map((item) => {
        return (
          <div className="comment-item">
            <div className="col-1 comment-item-profile-pic">
              <Link to={`/profile/${item.user_id}`}>
                <img src={item.author_image_icon}></img>
              </Link>
            </div>
            <div className="col comment-item-body">
              <p className="author-item-name">
                <Link to={`/profile/${item.user_id}`} className="author-item">
                  {item.author_title}
                </Link>
              </p>
              <p className="lightbox-comment-body">
                {showMore ? item.comment_body :`${item.comment_body.slice(0, 250)}`}
                {item.comment_body && item.comment_body.length > 250 && (
                  <span
                    className="show-more-less-btn"
                    onClick={() => setShowMore(!showMore)}
                  >
                    {showMore ? " Show less" : "... Show more"}
                  </span>
                )}
              </p>
              <CommentActions
                handles={{
                  handleLike: handleLike,
                  handleUnlike: handleUnlike,
                }}
                is_like={item.like.isLike}
                action_id={item.action_id}
                comment_id={item.comment_id}
              />
            </div>
          </div>
        );
      })}
      {
        fetchedComments.length !== 0 && fetchedComments.length < totalComments ? (<LoadMoreComments _loadMore={_loadMore}/>) : null
      }
      
    </>
  );
};
